import { styled } from '@linaria/react'
import { useTranslation } from 'react-i18next'
import soccer from '../../assets/home-v3/soccer.webp'
import slot from '../../assets/home-v3/slot.webp'
import chips from '../../assets/home-v3/chips.webp'
import ellipse from '../../assets/home-v3/ellipse.webp'
import { Link, useNavigate } from '@tanstack/router'
import { useModal } from '@ebay/nice-modal-react'
import LoginModal from '../common/log-in-modal'
import { useBoundStore } from '../../store/store'
import { CASINO_CATEGORIES } from '../../constants/casino'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const Container = styled.div`
  padding: 24px 12px;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 24px;
  @media (min-width: 1200px) {
    gap: 120px;
    padding: 100px 12px 110px;
  }
`

const Item = styled.div`
  .icon-container {
    position: relative;
    margin-bottom: 12px;
    .icon {
      width: 100%;
      height: 100%;
      max-height: 102px;
      max-width: 157px;
      &.slot {
        max-height: 140px;
        max-width: 210px;
        margin-right: -24px;
        margin-bottom: -5px;
      }
      &.chips {
        max-height: 160px;
        max-width: 160px;
      }
    }
    .ellipse {
      position: absolute;
      bottom: -2px;
      width: 122px;
      left: 50%;
      transform: translateX(-50%);
      z-index: -1;
      aspect-ratio: 61 / 16;
    }
  }
  .name {
    font-weight: 700;
    font-size: 24px;
    color: var(--highlight);
  }
  .label {
    font-size: 20px;
    margin-top: 2px;
  }
  .terms {
    margin-top: 4px;
    font-size: 16px;
    color: #7a7a7a;
    text-decoration: underline;
  }
  @media (min-width: 1200px) {
    &:first-child {
      padding-bottom: 23px;
    }
    .icon-container {
      margin-bottom: 16px;
      .icon {
        max-height: 170px;
        max-width: 270px;
        &.slot {
          max-height: 196px;
          max-width: 336px;
        }
        &.chips {
          max-height: 210px;
          max-width: 210px;
        }
      }
      .ellipse {
        width: 252px;
      }
    }
    .name {
      font-size: 36px;
    }
    .label {
      font-size: 22px;
    }
  }
`

const Btn = styled.button`
  padding: 12px 0;
  background-color: var(--primary-btn-bg);
  border-radius: 6px;
  width: 100%;
  text-align: center;
  border-radius: 6px;
  margin: 0 auto 12px;
  display: block;
  p {
    font-size: 16px;
    color: var(--primary-btn-txt);
    text-transform: uppercase;
  }
  &.login {
    background-color: var(--highlight);
  }
`

const BtnContainer = styled.div`
  gap: 12px;
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (min-width: 1200px) {
    display: none;
  }
`

const Promotions = () => {
  const navigate = useNavigate()
  const login = useModal(LoginModal)
  const username = useBoundStore(state => state.user.username)
  const { t } = useTranslation('common')

  return (
    <Container className="flx-ctr">
      <Item className="v-flx-ctr">
        <div className="icon-container">
          <LazyLoadImage
            className="icon"
            src={soccer}
            alt="soccer"
            style={{ aspectRatio: '267 / 197' }}
          />
          <LazyLoadImage className="ellipse" src={ellipse} alt="ellipse" />
        </div>
        <p className="name">Apuestas Deportivas</p>
      </Item>
      <Item className="v-flx-ctr">
        <div className="icon-container">
          <LazyLoadImage
            className="icon slot"
            src={slot}
            alt="slot"
            style={{ aspectRatio: '547 / 332' }}
          />
          <LazyLoadImage className="ellipse" src={ellipse} alt="ellipse" />
        </div>
        <p className="name">Slots</p>
        <Link
          className="terms"
          to="/promotions/$promoId"
          params={{ promoId: '323-bono-del-100-en-tu-primer-depsito' }}>
          Términos y Condiciones
        </Link>
      </Item>
      <Item className="v-flx-ctr">
        <div className="icon-container">
          <LazyLoadImage
            className="icon chips"
            src={chips}
            alt="chips"
            style={{ aspectRatio: '1' }}
          />
          <LazyLoadImage
            className="ellipse"
            src={ellipse}
            alt="ellipse"
            style={{ aspectRatio: '61 / 16' }}
          />
        </div>
        <p className="name">Mesas en Vivo</p>
        <Link
          className="terms"
          to="/promotions/$promoId"
          params={{ promoId: '327-bono-sin-depsito' }}>
          Términos y Condiciones
        </Link>
      </Item>
      <BtnContainer>
        {username ? (
          <Btn
            onClick={() =>
              navigate({
                to: '/casino/$category',
                params: { category: CASINO_CATEGORIES[0].label },
              })
            }>
            <p>JUGAR AHORA</p>
          </Btn>
        ) : (
          <>
            <Btn onClick={() => navigate({ to: '/register' })}>
              <p>{t('register')}</p>
            </Btn>
            <Btn className="login" onClick={() => login.show()}>
              <p>{t('login')}</p>
            </Btn>
          </>
        )}
      </BtnContainer>
    </Container>
  )
}

export default Promotions
